import { render, staticRenderFns } from "./pos-addVendro.vue?vue&type=template&id=5724a2cc"
import script from "./pos-addVendro.vue?vue&type=script&lang=js"
export * from "./pos-addVendro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports